<span *ngIf="value; else emptyValue">{{ value | personName }}</span>
<ng-template #emptyValue>
  <span *ngIf="emptyValueDisplay">{{ emptyValueDisplay }}</span>
</ng-template>